import { Component, inject } from '@angular/core';
import { InactivitySessionManagerService } from '../services/inactivity-session-manager.service';

@Component({
  selector: 'app-session-timeout-modal',
  standalone: true,
  template: `
    @if (session.showWarning()) {
      <div
        class="fixed inset-0 z-[10000] flex items-center justify-center p-4"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-timeout-title"
        aria-describedby="session-timeout-desc"
      >
        <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" aria-hidden="true"></div>
        <div
          class="relative z-[10001] w-full max-w-md rounded-lg border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-700 dark:bg-gray-800"
        >
          <h2
            id="session-timeout-title"
            class="text-lg font-semibold text-gray-900 dark:text-white"
          >
            Session timeout
          </h2>
          <p id="session-timeout-desc" class="mt-2 text-sm text-gray-600 dark:text-gray-300">
            Your session is about to expire due to inactivity.
            @if (session.remainingSeconds() !== null) {
              <span class="mt-1 block font-medium text-gray-900 dark:text-white">
                Time remaining: {{ session.remainingSeconds() }}s
              </span>
            }
          </p>
          <div class="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              class="inline-flex justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
              (click)="session.logOut()"
            >
              Logout
            </button>
            <button
              type="button"
              class="inline-flex justify-center rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90"
              (click)="session.stayLoggedIn()"
            >
              Stay Logged In
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class SessionTimeoutModalComponent {
  readonly session = inject(InactivitySessionManagerService);
}
